import { StorageBucket } from 'models/storage/bucket';

const buckets: Array<StorageBucket> = [];

/**
 * Loads css file(s)
 */
export async function loadCSS(urlOrList: string | Array<string>) {
    const urls = _.isArray(urlOrList) ? urlOrList : [urlOrList];
    const tasks = urls.map(url => awaitSingleCSSFile(url));

    await Promise.all(tasks);
}

/**
 * awaits css file with provided URL
 * @param url
 */
async function awaitSingleCSSFile(url: string) {
    let bucket = fetchFromCache(url);

    if (bucket == undefined) {
        bucket = createBucket(url);
        bucket.markLoading();

        await loadSingleCSSFile(url);

        bucket.markReady();
    } else {
        await bucket.isReady.when();
    }
}

/**
 * returns css bucket from cache if it exists
 * @param url bucket key
 */
function fetchFromCache(url: string) {
    return _(buckets).find(bucket => bucket.name() == url);
}

/**
 * Creates new bucket and adds to cache
 * @param url bucket key
 */
function createBucket(url: string) {
    const bucket = new StorageBucket(url);
    buckets.push(bucket);

    return bucket;
}

/**
 * Loads css file with provided URL
 */
function loadSingleCSSFile(url: string) {
    return new Promise<HTMLLinkElement>(resolve => {
        const tag = getCSSNode(url);
        const resolveFunc = () => resolve(tag);

        if (tag.onload !== undefined) {
            tag.onload = resolveFunc;
        } else if (tag.addEventListener) {
            tag.addEventListener('load', resolveFunc, false);
        } else {
            var track = new Image();

            track.onerror = resolveFunc;
            track.src = url;
        }

        attachNode(tag);
    });
}

function getCSSNode(url: string) {
    const cssTag = document.createElement("link");

    cssTag.setAttribute("rel", "stylesheet");
    cssTag.setAttribute("type", "text/css");
    cssTag.setAttribute("href", url);

    return cssTag;
}

/**
 * Attaches node to document
 * @param tag node to attach
 */
function attachNode(tag: HTMLElement) {
    document.head.appendChild(tag);
}